import { useSelector } from 'react-redux';

import { offerSelector } from 'shared/selectors';
import { FOfferType, getOfferType } from 'shared/utils/offer_type';

enum EEstimationTarget {
  flat = 0,
  house = 1,
  land = 2,
}

export function useEstimationTargetForUrl(): EEstimationTarget {
  const offer = useSelector(offerSelector);
  const offerType = getOfferType(offer);

  switch (offerType) {
    case FOfferType.Land:
      return EEstimationTarget.land;

    case FOfferType.House:
      return EEstimationTarget.house;

    default:
      return EEstimationTarget.flat;
  }
}
